
<dropdown-select-button (click)="addButton(selectedButtonType)" (selectedValue)="selectButtonType($event)">
  Add {{selectedButtonType}} button
  @for (item of buttonPositions; track item) {
    <dropdown-select-item [value]="item">
      {{item | titlecase}}
    </dropdown-select-item>
  }
</dropdown-select-button>

<div class="grid-x grid-margin-x grid-margin-y">
  @for (button of page.buttons; track button; let i = $index) {
    <div class="cell small-12">
      <div class="grid-x grid-margin-x">
        <div class="cell small-4">
          <label [attr.for]="button.label">Button <span class="bold">{{i+1}}</span> Label:</label>
          <input [attr.id]="button.label" type="text" class="no-margin-bottom" [(ngModel)]="button.label" />
        </div>
        <div class="cell small-6">
          <label>Button <span class="bold">{{i+1}}</span> Action:</label>
          <div class="grid-x">
            <div class="cell small-8">
              <select class="no-margin-bottom" [(ngModel)]="button.type">
                @for (option of getButtonOptions(button); track option) {
                  <option [value]="option.id">{{option.text}}</option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="cell small-4">
          <label>Button <span class="bold">{{i+1}}</span> Position:</label>
          <select class="no-margin-bottom" [ngModel]="button.position" (ngModelChange)="positionChanged(button, $event)">
            @for (option of buttonPositions; track option) {
              <option>{{option}}</option>
            }
          </select>
        </div>
        <div class="cell small-4 button-margin-top">
          <button (click)="showRulesEditor(button.id)">
            <svg-icon icon="icon-pencil" class="small minor-margin-left dark-gray"></svg-icon>
          </button>
          <button class="minor-margin-right" (click)="deleteButton(button.id)">
            <svg-icon icon="icon-trash" class="small minor-margin-left dark-gray"></svg-icon>
          </button>
          @if (button.special) {
            <label class="inline no-margin vertical-align-middle minor-margin-right" [for]="'shouldConfirm' + i">Confirm?</label>
            <input class="no-margin-bottom vertical-align-middle" [id]="'shouldConfirm' + i" type="checkbox" [(ngModel)]="button.confirmAction">
          }
          @if (button.special) {
            <label class="inline margin-left vertical-align-middle minor-margin-right" [for]="'shouldEnable' + i">Always Enable?</label>
            <input class="no-margin-bottom vertical-align-middle" [id]="'shouldEnable' + i" type="checkbox" [(ngModel)]="button.alwaysEnable">
          }
        </div>
      </div>
      <div class="grid-x grid-margin-x" [style.display]="ruleRequired(button) ? 'flex' : 'none'">
        <div class="cell small-12 flow-line-height">
          <span class="builder-warning border-none no-padding normal">
            A rule is required for this type of button to
            function
          </span>
        </div>
      </div>
    </div>
  }
</div>